<template>
  <div class="login-fail">
    <div class="login-fail-body">
      <img src="../../assets/images/unsuccess.svg" alt />
      <p>对不起，当前登录失败！</p>
      <p v-if="failMessage">{{ failMessage }}</p>
      <div>
        <el-button type="primary" @click="backLogin">返回登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      failMessage: "",
    };
  },
  methods: {
    backLogin() {
      this.$router.push({
        path: "/login",
      });
    },
  },
  mounted() {
    let queryInfo = getHeaders;
    if (queryInfo.errorMsg) {
      this.failMessage = decodeURIComponent(queryInfo.errorMsg);
    }
  },
  methods: {
    getHeaders() {
      var req = new XMLHttpRequest();
      req.open('GET', document.location.href, false);
      req.send(null);
      var headerArr = req.getAllResponseHeaders().split('\n');
      var headers = {};
      headerArr.forEach(item => {
        if (item !== '') {
          var index = item.indexOf(':');
          var key = item.slice(0, index);
          var value = item.slice(index + 1).trim();
          headers[key] = value;
        }

      })
      return headers;
    }
  }
};
</script>

<style lang="less">
.login-fail {
  .login-fail-body {
    width: 500px;
    height: 500px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    > p {
      text-align: center;
      font-size: 22px;
      color: #aaa;
      margin-top: 20px;
    }
    > div {
      margin-top: 40px;
      text-align: center;
      .el-button {
        font-size: 16px;
      }
    }
  }
}
</style>
